export const EmpresaUsuario = {
    razon_social: {
        header: 'Empresas',
        table: true,
        sort: true,
        filter: true,
        filterPlaceholder: 'Filtrar por razón social'
    },
    identificacion: {
        header: 'Identificación',
        table: true,
        sort: true,
        filter: true,
        filterPlaceholder: 'Filtrar por identificación'
    },
    fecha: {
        header: 'Fecha de asignación',
        table: true,
        sort: true,
        filter: false
    }
};